import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { dateTimeBR } from "../lib/format";
import { Card, CardHead, SlaPill } from "./common";
import { RequestDetailSheet } from "./RequestDetailSheet";

const TONE = { novas: ["bg-rose-500", "text-rose-700"], respostas: ["bg-rose-500", "text-rose-700"], em_andamento: ["bg-amber-400", "text-amber-700"],
  aguardando_cliente: ["bg-orange-500", "text-orange-700"], prontas: ["bg-violet-500", "text-violet-700"], concluidas: ["bg-emerald-500", "text-emerald-700"] };

function Item({ it, g, onOpen }) {
  return (
    <button onClick={() => onOpen(it)} data-testid={`demand-item-${it.protocol}`} className="w-full flex items-start gap-3 px-3 py-2.5 rounded-lg hover:bg-slate-50 text-left border-b last:border-0">
      <span className={`mt-1.5 h-2.5 w-2.5 rounded-full shrink-0 ${TONE[g][0]}`} />
      <span className="flex-1 min-w-0">
        <span className="block text-sm font-medium truncate">{it.type_label} — {it.employee_name || it.title}</span>
        <span className="block text-[11px] text-slate-500"><span className="font-mono text-indigo-700">#{it.protocol}</span> · {g === "novas" ? `Recebida ${dateTimeBR(it.created_at)}` : g === "respostas" ? `Respondeu ${dateTimeBR(it.client_reply_at)}` : it.status_label}{it.assignee_name && g !== "novas" ? ` · ${it.assignee_name}` : ""}</span>
      </span>
      {it.sla_state && g !== "concluidas" && <SlaPill s={it.sla_state} />}
    </button>
  );
}

export function CompanyDemands({ cid, name, onChanged }) {
  const nav = useNavigate();
  const [groups, setGroups] = useState(null);
  const [open, setOpen] = useState(null);
  const load = useCallback(() => api.get(`/backoffice/companies/${cid}/demands`).then((r) => setGroups(r.data)), [cid]);
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, [load]);
  if (!groups) return null;
  const openItem = (it) => (it.kind === "file" ? nav(`/backoffice/arquivos?company_id=${cid}`) : setOpen(it.id));
  return (
    <Card testid="company-demands">
      <CardHead title={`Central Operacional — ${name}`} hint="Tudo o que este cliente enviou para a DPdigi, no mesmo protocolo que ele acompanha no Portal Empresa. Atualiza a cada 30 segundos." />
      <div className="px-5 pb-5 grid lg:grid-cols-2 gap-4">
        {groups.map((g) => (
          <div key={g.key} className="border rounded-xl" data-testid={`demand-group-${g.key}`}>
            <div className={`flex items-center justify-between px-3 py-2 border-b text-sm font-semibold ${TONE[g.key][1]}`}><span>{g.label}</span><span className="font-mono text-xs" data-testid={`demand-group-count-${g.key}`}>{g.items.length}</span></div>
            <div className="max-h-72 overflow-y-auto px-1">{g.items.length ? g.items.map((it) => <Item key={it.id} it={it} g={g.key} onOpen={openItem} />) : <div className="text-xs text-slate-400 px-3 py-3">Nada aqui.</div>}</div>
          </div>))}
      </div>
      <RequestDetailSheet id={open} open={!!open} onOpenChange={(o) => !o && setOpen(null)} onChanged={() => { load(); onChanged && onChanged(); }} />
    </Card>
  );
}
